import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beliefs',
  templateUrl: './beliefs.component.html',
  styleUrls: ['./beliefs.component.css']
})
export class BeliefsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
